import { render } from "./AppDocumentsFiltered.vue?vue&type=template&id=99892cb6&scoped=true"
import script from "./AppDocumentsFiltered.vue?vue&type=script&lang=js"
export * from "./AppDocumentsFiltered.vue?vue&type=script&lang=js"

import "./AppDocumentsFiltered.vue?vue&type=style&index=0&id=99892cb6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99892cb6"]])

export default __exports__